import { useState, useRef, useMemo, useEffect } from 'react';
import useModal from "../../hooks/useModal";
import { useCurrentUserHook } from '../Authentication/useUserHook';
import CheckAccess from './CheckAccess';
import FacilityService from '../Organizations/MedicalCareFacility/FacilityService';
import RoleService from './RoleService';

const useRoleAccessHook = (sid) => {
  const {currentUser} = useCurrentUserHook();

  const getAccessList = (pkey, sid) =>{
    return currentUser.current_member.permissions?.[pkey]?.[sid];
  }

  const checkMenuAccess = (sid, rwsid='read') =>{
    return getAccessList('menu', sid)?.includes(rwsid);
  }

  const checkRwMenuAccess = (rwsid='read') =>{
    return getAccessList('menu', sid)?.includes(rwsid);
  }

  const getLanguageAccessList = (sid) =>{
    return getAccessList('language', sid);
  }

  return {
    getAccessList,
    getLanguageAccessList,
    checkMenuAccess,
    checkRwMenuAccess
  }
}

const useUserPermissionHook = ({pkey, sid}) => {
  let {current: scope} = useRef({});
  const {currentUser} = useCurrentUserHook();

  useEffect(()=>{
    scope.activeAccess = currentUser.current_member.permissions?.[pkey]?.[sid];
  }, [pkey, sid])

  const hasAccess = (rwsid) => scope.activeAccess?.includes(rwsid);

  return {
    hasAccess
  }
}

export {useRoleAccessHook, useUserPermissionHook};